// src/pages/AlunosPorPolo.js

import React from 'react';
import AlunosTable from '../components/AlunosTable';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const AlunosPorPolo = () => {
    return (
        <>
            <div className="main-content">
                <Navbar />
            </div>
            <div className="content">
                <Sidebar />
            </div>
            <div className='table-alunos'>
                <AlunosTable />
            </div>
        </>
    );
};

export default AlunosPorPolo;
